app.service('deliveryPointLocation', function () {

	function findPlaceByAddress(address, setPoint) {
		const options = {
			componentRestrictions: { country: "pl" },
			address: address
		};
		const geocoder = new google.maps.Geocoder();
		geocoder.geocode(options, function (results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				const partialMatch = results[0]["partial_match"] || false;
				setPoint(results[0].geometry.location, partialMatch);
			} else {
				setPoint(false);
			}
		});
	}

	return {
		findPlaceByAddress
	};
});